import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreviewCardComponent } from './preview-card.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { LazyLoadImageDirective } from '../../directives/lazy-load-image.directive';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [
    PreviewCardComponent,
    LazyLoadImageDirective
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MatProgressSpinnerModule,
    MatIconModule
  ],
  exports: [
    PreviewCardComponent,
    LazyLoadImageDirective
  ],
  providers: [],
})
export class PreviewCardModule {}
